export default "__VITE_ASSET__ab45132c__"